"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobAppealPointSchema = exports.AppealPointSchema = void 0;
const zod_1 = require("zod");
exports.AppealPointSchema = zod_1.z.object({
    id: zod_1.z.string(),
    category: zod_1.z.string(),
    point: zod_1.z.string(),
    localized: zod_1.z.any().nullish(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.JobAppealPointSchema = zod_1.z.object({
    appealPointId: zod_1.z.string(),
    jobPostingId: zod_1.z.string(),
});
